import React from "react";
import { PageConfig } from "pageStructure/options/default";

export const pageConfigContext = React.createContext<PageConfig>({} as PageConfig);

export const PageConfigProvider = pageConfigContext.Provider;

export function usePageConfig(): PageConfig {
    return React.useContext(pageConfigContext);
}
